"use strict";

exports.__esModule = true;
var _useInterval = require("./useInterval");
Object.keys(_useInterval).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useInterval[key]) return;
  exports[key] = _useInterval[key];
});
var _useNodeBoundingRect = require("./useNodeBoundingRect");
Object.keys(_useNodeBoundingRect).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useNodeBoundingRect[key]) return;
  exports[key] = _useNodeBoundingRect[key];
});